import { waterfall } from '$lib/utils/objects';
import { EventType } from './common';
import { Sentry } from '$lib/services/sentry';

/**
 * @type {import('./types').Transports.FirebaseTransport}
 */
export class FirebaseTransport {
	/**
	 * @param {string} name - name of the transport
	 * @param {{ [K in EventType]: Array<Function>; }} tranformMap the map of transformation
	 * @param {import('$lib/services/app/').AppService} appService appService for communicating to in-app
	 */
	constructor(name, tranformMap, appService) {
		this.name = name;
		this.transformMap = tranformMap;
		this.appService = appService;
	}

	/**
	 * @param {import("./types").Events.Event<EventType, object>} event - event to send
	 * @returns {Promise<boolean>}
	 */
	async consume(event) {
		if (event) {
			const eventType = event.type;
			let transformedEvent = event;
			if (this.transformMap[eventType]) {
				transformedEvent = await waterfall(this.transformMap[eventType], event);
			}
			await this.emit(transformedEvent);

			return true;
		}
		return false;
	}

	/**
	 * @param {import("./types").Events.Event<EventType, object>} events - event to send
	 * @returns {Promise<boolean>}
	 */
	async emit(events) {
		const eventsArray = Array.isArray(events) ? events : [events];
		/** @type {Array<boolean>} */
		const results = [];
		for (const event of eventsArray) {
			try {
				await this.appService.logEvent(event);
				results.push(true);
			} catch (e) {
				results.push(false);
				this.logException(e, event);
			}
		}
		return true;
	}

	/**
	 * @param {object | unknown} exception - the error being thrown
	 * @param {object} event - the event for which error occurs
	 * @returns {void}
	 */
	logException(exception, event) {
		Sentry.captureException(exception, {
			extra: {
				source: 'Error: Firebase Transport',
				event
			}
		});
	}
}
